// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kNhu","field":"styles_field__1ggWe","fieldCol":"styles_fieldCol__1Fzpy","diffCol":"styles_diffCol__MG_ZL","diff":"styles_diff__scaIL"};